import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';

export const FETCH_FRONT_SHEET_DATA = 'FETCH_FRONT_SHEET_DATA';
export const SET_LOADING_WITH_MESSAGE = 'SET_LOADING_WITH_MESSAGE';

export const getFrontSheetData = (url: string, reportId: any) => {
  return async dispatch => {
    try {
      return Api.get(url, {... reportId }).then(
        (result: ApiResponse<any>) => {
          dispatch(fetchFrontSheetData(result.data));
          return Promise.resolve(result.data);
        }
      );
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const showLoadingWithMessage = (showLoading:boolean, message: string = 'Loading') => {
  return {
    type: SET_LOADING_WITH_MESSAGE,
    showLoading,
    message
  };
};

export const fetchFrontSheetData = items => ({
  type: FETCH_FRONT_SHEET_DATA,
  value: items
});
